var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { attrs: { separator: "" } },
    _vm._l(_vm.validateProp.units.$each.$iter, function(unit) {
      return _c(
        "q-collapsible",
        {
          key: unit.$model.id,
          class: unit.$model.showing_enabled
            ? "text-positive"
            : "text-negative",
          attrs: {
            group: "units",
            icon: unit.$model.showing_enabled ? "toggle_on" : "toggle_off",
            label: unit.$model.name || _vm.currentProperty.short_address,
            opened: true
          }
        },
        [
          _c("div", { staticClass: "text-black" }, [
            _c(
              "ul",
              [
                _vm.editMode
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Unit name: ")]),
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: unit.name.$error,
                              "error-label": "This field is required"
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: { disable: _vm.hasAppfolioNewIntergation },
                              model: {
                                value: unit.$model.name,
                                callback: function($$v) {
                                  _vm.$set(unit.$model, "name", $$v)
                                },
                                expression: "unit.$model.name"
                              }
                            })
                          ],
                          1
                        ),
                        _c("strong", [
                          _vm._v("Unit override AppFolio property code: ")
                        ]),
                        _c(
                          "q-field",
                          [
                            _c("q-input", {
                              model: {
                                value: unit.$model.pms_code,
                                callback: function($$v) {
                                  _vm.$set(unit.$model, "pms_code", $$v)
                                },
                                expression: "unit.$model.pms_code"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "li",
                  [
                    _c("strong", [_vm._v("Created at: ")]),
                    _c("SdDatetime", {
                      staticClass: "inline-block",
                      attrs: {
                        value: unit.$model.created_at,
                        "market-id": _vm.currentProperty.market_id,
                        timezone: _vm.currentProperty.timezone
                      }
                    })
                  ],
                  1
                ),
                _c("li", [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.getListingContact()) }
                  })
                ]),
                _c("li", [
                  _c("strong", [_vm._v("Active for showings: ")]),
                  _c(
                    "span",
                    {
                      class: unit.$model.showing_enabled
                        ? "text-positive"
                        : "text-negative"
                    },
                    [_vm._v(_vm._s(unit.$model.showing_enabled ? "Yes" : "No"))]
                  )
                ]),
                unit.$model.last_showing_profile
                  ? _c(
                      "li",
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              unit.$model.showing_enabled
                                ? "Activation time"
                                : "Last activation time"
                            ) + ": "
                          )
                        ]),
                        _c("SdDatetime", {
                          staticClass: "inline-block",
                          attrs: {
                            value: unit.$model.last_showing_profile.created_at,
                            "market-id": _vm.currentProperty.market_id,
                            timezone: _vm.currentProperty.timezone
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile && !unit.$model.showing_enabled
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Inactivation time: ")]),
                        _c("SdDatetime", {
                          staticClass: "inline-block",
                          attrs: {
                            value: unit.$model.last_showing_profile.deleted_at,
                            "market-id": _vm.currentProperty.market_id,
                            timezone: _vm.currentProperty.timezone
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile && !unit.$model.showing_enabled
                  ? _c("li", [
                      _c("strong", [_vm._v("Deactivation reason: ")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.getDeactivationReason(
                              unit.$model.last_showing_profile
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                unit.$model.last_showing_profile
                  ? _c("li", [
                      _c("strong", [_vm._v("Tours count: ")]),
                      _vm._v(
                        " " +
                          _vm._s(unit.$model.last_showing_profile.tours_count) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                !unit.$model.last_showing_profile.is_vacant &&
                unit.$model.last_showing_profile.tenants
                  ? [
                      _c("li", [
                        _vm._v("\n            Tenants:\n            "),
                        _c(
                          "ul",
                          _vm._l(
                            unit.$model.last_showing_profile.tenants,
                            function(tenant, index) {
                              return _c(
                                "li",
                                { key: "tenant_" + index, staticClass: "my-2" },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(tenant.full_name))
                                  ]),
                                  tenant.formatted_phone_number
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "mx-2",
                                          attrs: {
                                            href:
                                              "tel:" +
                                              tenant.formatted_phone_number
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              tenant.formatted_phone_number
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  tenant.email
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "mx-2",
                                          attrs: {
                                            href: "mailto:" + tenant.email
                                          }
                                        },
                                        [_vm._v(_vm._s(tenant.email))]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }
                          )
                        )
                      ])
                    ]
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                !unit.$model.listing_identifier
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Property URL: ")]),
                        _vm.editMode &&
                        unit.$model.last_showing_profile.deleted_at === null
                          ? _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    unit.last_showing_profile.property_url
                                      .$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  model: {
                                    value:
                                      unit.$model.last_showing_profile
                                        .property_url,
                                    callback: function($$v) {
                                      _vm.$set(
                                        unit.$model.last_showing_profile,
                                        "property_url",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "unit.$model.last_showing_profile.property_url"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    unit.$model.last_showing_profile
                                      .property_url,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    unit.$model.last_showing_profile
                                      .property_url
                                  )
                                )
                              ]
                            )
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.syndication_status
                  ? _c(
                      "li",
                      _vm._l(
                        unit.$model.last_showing_profile.syndication_status,
                        function(syndication) {
                          return _c("p", { key: syndication.url }, [
                            _vm._v(
                              "\n            portal: " +
                                _vm._s(syndication.portal) +
                                " - " +
                                _vm._s(syndication.url) +
                                "\n          "
                            )
                          ])
                        }
                      )
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Application form URL: ")]),
                        _vm.editMode &&
                        unit.$model.last_showing_profile.deleted_at === null
                          ? _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    unit.last_showing_profile
                                      .application_form_url.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  model: {
                                    value:
                                      unit.$model.last_showing_profile
                                        .application_form_url,
                                    callback: function($$v) {
                                      _vm.$set(
                                        unit.$model.last_showing_profile,
                                        "application_form_url",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "unit.$model.last_showing_profile.application_form_url"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    unit.$model.last_showing_profile
                                      .application_form_url,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    unit.$model.last_showing_profile
                                      .application_form_url
                                  )
                                )
                              ]
                            )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.resolveSmartDevice(unit.$model)
                  ? _c("li", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.capitalizeFirstLetter(
                              unit.$model.last_showing_profile.access_hardware
                            )
                          ) + " serial number: "
                        )
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            unit.$model.last_showing_profile.device
                              .serial_number
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                !_vm.smartDeviceProviders.includes(
                  unit.$model.last_showing_profile.access_hardware
                )
                  ? _c(
                      "li",
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.capitalizeFirstLetter(
                                unit.$model.last_showing_profile
                                  .access_hardware || "Access"
                              )
                            ) + " code: "
                          )
                        ]),
                        _vm.editMode &&
                        unit.$model.last_showing_profile.deleted_at === null
                          ? _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    unit.last_showing_profile.lock_box_code
                                      .$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  model: {
                                    value:
                                      unit.$model.last_showing_profile
                                        .lock_box_code,
                                    callback: function($$v) {
                                      _vm.$set(
                                        unit.$model.last_showing_profile,
                                        "lock_box_code",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "unit.$model.last_showing_profile.lock_box_code"
                                  }
                                })
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  unit.$model.last_showing_profile.lock_box_code
                                )
                              )
                            ])
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.type !==
                  _vm.ShowingTypes.PUBLISH_LISTING
                  ? _c(
                      "li",
                      { staticClass: "notes-to-agent" },
                      [
                        _c("strong", [_vm._v("Notes to agent: ")]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.editMode
                                ? ""
                                : unit.$model.last_showing_profile.comments
                            ) +
                            "\n          "
                        ),
                        _vm.editMode &&
                        unit.$model.last_showing_profile.deleted_at === null
                          ? _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    unit.last_showing_profile.comments.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: { type: "textarea" },
                                  model: {
                                    value:
                                      unit.$model.last_showing_profile.comments,
                                    callback: function($$v) {
                                      _vm.$set(
                                        unit.$model.last_showing_profile,
                                        "comments",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "unit.$model.last_showing_profile.comments"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Notes to prospect: ")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.editMode
                                ? ""
                                : unit.$model.last_showing_profile.general_notes
                            ) +
                            "\n          "
                        ),
                        _vm.editMode &&
                        unit.$model.last_showing_profile.deleted_at === null
                          ? _c(
                              "q-field",
                              {
                                attrs: {
                                  error:
                                    unit.last_showing_profile.comments.$error,
                                  "error-label": "This field is required"
                                }
                              },
                              [
                                _c("q-input", {
                                  attrs: { type: "textarea" },
                                  model: {
                                    value:
                                      unit.$model.last_showing_profile
                                        .general_notes,
                                    callback: function($$v) {
                                      _vm.$set(
                                        unit.$model.last_showing_profile,
                                        "general_notes",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "unit.$model.last_showing_profile.general_notes"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.paused_until !== null
                  ? _c(
                      "li",
                      [
                        _c("strong", [_vm._v("Showing paused until: ")]),
                        unit.$model.last_showing_profile.paused_until ===
                        _vm.Property.INDEFINITE_PAUSE_TIME
                          ? _c("span", [
                              _vm._v(
                                "\n            Paused indefinitely\n          "
                              )
                            ])
                          : _c("SdDatetime", {
                              staticClass: "inline-block",
                              attrs: {
                                value:
                                  unit.$model.last_showing_profile.paused_until,
                                "market-id": _vm.currentProperty.market_id,
                                timezone: _vm.currentProperty.timezone
                              }
                            })
                      ],
                      1
                    )
                  : _vm._e(),
                unit.$model.last_showing_profile &&
                _vm.currentProperty.market_id &&
                !unit.$model.last_showing_profile.is_self_showing &&
                !unit.$model.last_showing_profile.deleted_at
                  ? _c(
                      "li",
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v(
                                    "\n                Tour budget\n              "
                                  )
                                ]),
                                _c("q-item-tile", {
                                  attrs: { sublabel: "" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getTourBudgetSubLabel(
                                        unit.$model.last_showing_profile
                                      )
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.editMode &&
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.deleted_at === null
                  ? void 0
                  : _vm._e(),
                !_vm.editMode && unit.$model.last_showing_profile
                  ? [
                      unit.$model.last_showing_profile.deleted_at === null
                        ? [
                            _c("li", [
                              _c("strong", [_vm._v("Scheduling Link: ")]),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: unit.$model.landing_page_url.includes(
                                      "http"
                                    )
                                      ? unit.$model.landing_page_url
                                      : "//" + unit.$model.landing_page_url,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(unit.$model.landing_page_url))]
                              )
                            ]),
                            unit.$model.last_showing_profile.is_vacant === false
                              ? _c("li", [
                                  _c("strong", [
                                    _vm._v("Tenant Schedule Link: ")
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: unit.$model.landing_page_url.includes(
                                          "http"
                                        )
                                          ? unit.$model.landing_page_url + "/t"
                                          : "//" +
                                            unit.$model.landing_page_url +
                                            "/t",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          unit.$model.landing_page_url + "/t"
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            unit.$model.last_showing_profile
                              .formatted_phone_line
                              ? _c("li", [
                                  _c("strong", [_vm._v("Phone Line: ")]),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "tel:" +
                                          unit.$model.last_showing_profile
                                            .formatted_phone_line,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          unit.$model.last_showing_profile
                                            .formatted_phone_line
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _c("li", [
                        _c("strong", [_vm._v("Pre-screening: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              unit.$model.last_showing_profile
                                .pre_screening_disabled_at
                                ? "Disabled"
                                : "Enabled"
                            ) +
                            "\n          "
                        )
                      ]),
                      _c("li", [
                        _c("strong", [_vm._v("Showing type: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.ShowingTypesDisplay[
                                unit.$model.last_showing_profile.type
                              ]
                            ) +
                            "\n          "
                        )
                      ])
                    ]
                  : _vm._e(),
                !_vm.editMode &&
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.showing_windows.length
                  ? [
                      _c(
                        "li",
                        [
                          _c("strong", [_vm._v("Showing windows: ")]),
                          _vm._l(
                            unit.$model.last_showing_profile.showing_windows,
                            function(showingWindow) {
                              return _c(
                                "q-chip",
                                {
                                  key: showingWindow.id,
                                  staticClass: "q-mr-xs",
                                  attrs: { dense: "" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.moment
                                          .weekdays()
                                          [showingWindow.week_day].substring(
                                            0,
                                            3
                                          )
                                      ) +
                                      ":\n              " +
                                      _vm._s(
                                        _vm
                                          .moment(
                                            showingWindow.from_hour,
                                            "HH:mm:ss"
                                          )
                                          .format("h:mm A")
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm
                                          .moment(
                                            showingWindow.to_hour,
                                            "HH:mm:ss"
                                          )
                                          .format("h:mm A")
                                      ) +
                                      "\n              - " +
                                      _vm._s(
                                        _vm.showingWindowAssigneeNames(
                                          showingWindow
                                        )
                                      )
                                  ),
                                  _vm.showingWindowAssignmentStrategyLabel(
                                    showingWindow
                                  )
                                    ? _c(
                                        "span",
                                        { staticClass: "text-grey-7 q-ml-xs" },
                                        [
                                          _vm._v(
                                            "\n                (" +
                                              _vm._s(
                                                _vm.showingWindowAssignmentStrategyLabel(
                                                  showingWindow
                                                )
                                              ) +
                                              ")\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            }
                          )
                        ],
                        2
                      ),
                      _c("li", [
                        _c("strong", [_vm._v("Showdigs agent backup: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              unit.$model.last_showing_profile
                                .is_agent_backup_enabled
                                ? "Enabled"
                                : "Disabled"
                            ) +
                            "\n          "
                        )
                      ])
                    ]
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolvePropertyScreening(
                  unit.$model.last_showing_profile,
                  "minimum_credit_score"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Minimum credit score:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolvePropertyScreening(
                              unit.$model.last_showing_profile,
                              "minimum_credit_score"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolvePropertyScreening(
                  unit.$model.last_showing_profile,
                  "minimum_income_rent_ratio"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Minimum income to rent ratio:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolvePropertyScreening(
                              unit.$model.last_showing_profile,
                              "minimum_income_rent_ratio"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolvePropertyScreening(
                  unit.$model.last_showing_profile,
                  "eviction_history"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("eviction history policy:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolvePropertyScreening(
                              unit.$model.last_showing_profile,
                              "eviction_history"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolvePropertyScreening(
                  unit.$model.last_showing_profile,
                  "smoking_policy"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("smoking policy:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolvePropertyScreening(
                              unit.$model.last_showing_profile,
                              "smoking_policy"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolvePropertyScreening(
                  unit.$model.last_showing_profile,
                  "pet_policy"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("pet policy:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolvePropertyScreening(
                              unit.$model.last_showing_profile,
                              "pet_policy"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.get(
                  unit.$model.last_showing_profile,
                  "screening_criteria.availability_date"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Availability Date")]),
                      _vm._v(
                        "\n          From " +
                          _vm._s(
                            _vm
                              .momentUtil(
                                unit.$model.last_showing_profile
                                  .screening_criteria.availability_date,
                                _vm.currentProperty.timezone
                              )
                              .toDisplayMonthAndDayFormat()
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolveShowingScreening(
                  unit.$model.last_showing_profile,
                  "move_in_date"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Expected move in date")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolveShowingScreening(
                              unit.$model.last_showing_profile,
                              "move_in_date"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolveShowingScreening(
                  unit.$model.last_showing_profile,
                  "move_in_cost"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Move in cost:")]),
                      _vm._v(
                        "\n          $" +
                          _vm._s(
                            _vm.resolveShowingScreening(
                              unit.$model.last_showing_profile,
                              "move_in_cost"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolveShowingScreening(
                  unit.$model.last_showing_profile,
                  "maximum_allowed_tenants"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Maximum allowed tenants:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolveShowingScreening(
                              unit.$model.last_showing_profile,
                              "maximum_allowed_tenants"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                _vm.resolveShowingScreening(
                  unit.$model.last_showing_profile,
                  "minimum_lease_length"
                )
                  ? _c("li", [
                      _c("strong", [_vm._v("Minimum lease length:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.resolveShowingScreening(
                              unit.$model.last_showing_profile,
                              "minimum_lease_length"
                            )
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode && unit.$model.bedrooms
                  ? _c("li", [
                      _c("strong", [_vm._v("Bedrooms")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(unit.$model.bedrooms) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode && unit.$model.bathrooms
                  ? _c("li", [
                      _c("strong", [_vm._v("Bathrooms:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(unit.$model.bathrooms) +
                          "\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode && unit.$model.size
                  ? _c("li", [
                      _c("strong", [_vm._v("Size:")]),
                      _vm._v(
                        "\n          " +
                          _vm._s(unit.$model.size) +
                          " square feet\n        "
                      )
                    ])
                  : _vm._e(),
                !_vm.editMode &&
                unit.$model.last_showing_profile &&
                unit.$model.last_showing_profile.rent
                  ? _c("li", [
                      _c("strong", [_vm._v("Rent:")]),
                      _vm._v(
                        "\n          $" +
                          _vm._s(unit.$model.last_showing_profile.rent) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }